import { render, staticRenderFns } from "./GeodataPicker.vue?vue&type=template&id=22454d1a"
import script from "./GeodataPicker.vue?vue&type=script&lang=js"
export * from "./GeodataPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports